// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YLnu5361IJ8BQKs5uu4X{margin-top:28px}.p9XK_ooV_2gj2t4Q5eeo{margin:0 8px}.n8Whmcgn1y0ITrmZlPum{margin:0 8px 8px}.yvEeGEFQ63YsDt0zXudO{color:var(--content-brand-primary);font-size:14px;font-weight:500}.sjaXU7LCK2EqlxHmbXWj{padding:24px 0}.EEP9xRCZsOOIzsvgrpnE{color:var(--content-neutral-primary)}.SRY3rciuPqEXaMGimLhr{color:var(--content-primary-tertiary);justify-content:center;align-items:center;padding:24px 8px 14px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `YLnu5361IJ8BQKs5uu4X`,
	"list": `p9XK_ooV_2gj2t4Q5eeo`,
	"meetingList": `n8Whmcgn1y0ITrmZlPum`,
	"connectBtn": `yvEeGEFQ63YsDt0zXudO`,
	"loading": `sjaXU7LCK2EqlxHmbXWj`,
	"tooltipIcon": `EEP9xRCZsOOIzsvgrpnE`,
	"noResults": `SRY3rciuPqEXaMGimLhr`
};
export default ___CSS_LOADER_EXPORT___;
